
import { computed, defineComponent, PropType, ref } from "vue";
import VueFeather from "vue-feather";

// Single-value picker: user adds tag NAMES (not key=value pairs) from the
// sensor-tag registry, backed by a plain string[] v-modelled by the parent.
export default defineComponent({
  name: "TagSinglePicker",
  components: { VueFeather },
  props: {
    modelValue: {
      type: Array as PropType<string[]>,
      required: true,
    },
    sensorTagOptions: {
      type: Object as PropType<Record<string, string[]>>,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    inputId: {
      type: String,
      required: true,
    },
    labelTitle: {
      type: String,
      default: "",
    },
    helpText: {
      type: String,
      default: "",
    },
    addPlaceholder: {
      type: String,
      default: "— Select a tag to add —",
    },
    removeAriaLabel: {
      type: Function as PropType<(tag: string) => string>,
      default: (tag: string): string => `Remove ${tag}`,
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    // Pending selection stays "" between adds so the user can keep adding.
    const pending = ref<string>("");

    const availableOptions = computed<string[]>(() =>
      Object.keys(props.sensorTagOptions)
        .filter((t) => !props.modelValue.includes(t))
        .sort()
    );

    const addTag = () => {
      const tag = pending.value;
      if (!tag) return;
      if (!props.modelValue.includes(tag)) {
        emit("update:modelValue", [...props.modelValue, tag]);
      }
      pending.value = "";
    };

    const removeTag = (tag: string) => {
      emit(
        "update:modelValue",
        props.modelValue.filter((t) => t !== tag)
      );
    };

    return { pending, availableOptions, addTag, removeTag };
  },
});
